export default __webpack_public_path__ + "static/media/pq_united_center.f3054228.svg";